import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Game, GamesService } from 'core/index';
import { StoreService } from 'core/services/store.service';
import { GamesListService } from './games-list.service';

@Component({
  selector: 'lms-games-list',
  templateUrl: './games-list.component.html',
  styleUrls: ['./games-list.component.scss'],
  providers: [GamesListService]
})
export class GamesListComponent implements OnInit, OnChanges {
  @Input() listId: string;
  @Input() options: any;

  games: Game[];
  public dataSource: any;

  constructor(private gamesService: GamesService, private gamesListService: GamesListService, private router: Router) {}

  public ngOnInit(): void {}

  async ngOnChanges() {
    this.dataSource = await this.gamesListService.getDatasource(this.listId, this.options);
  }

  public ngOnDestroy(): void {
    StoreService.remove(this.listId);
  }

  public onClickRow(games): void {
    this.router.navigate(['/games', games.id]);
  }

  public onDatasourceUpdate(dataSource): void {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }
}
